<template>
  <b-modal
    ref="modalMakeItProductBonus"
    size="md"
    body-class="p-2"
    static
    hide-footer
    hide-header
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <img
      src="https://storage.googleapis.com/komerce/assets/icons/warning.svg"
      alt="Konfirmasi Aktivasi Bonus Produk"
      class="h-[102px] w-[110px] mx-auto mb-[24px]"
    >
    <h3 class="text-black font-semibold text-[20px] text-center mb-[8px]">
      Aktifkan Produk Bonus
    </h3>
    <p class="text-center text-black">
      Apakah kamu ingin mengaktifkan produk ini sebagai produk bonus?
    </p>
    <div class="flex gap-[8px]">
      <b-button
        variant="primary"
        class="!w-full"
        @click="handleSubmitProduct(true)"
      >
        Ya
      </b-button>
      <b-button
        variant="outline-secondary"
        class="!w-full"
        @click="handleSubmitProduct(false)"
      >
        Tidak
      </b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalMakeItProductBonus',
  data() {
    return {
      index: null,
      id: null,
    }
  },
  methods: {
    show({
      index,
      id,
    }) {
      this.index = index
      this.id = id
      this.$refs.modalMakeItProductBonus.show()
    },
    hide() {
      this.$refs.modalMakeItProductBonus.hide()
    },
    handleSubmitProduct(confirmation) {
      this.$emit('on-confirm', {
        id: this.id,
        indexProductBonus: this.index,
        confirmed: confirmation,
      })
      this.hide()
    },
  },
}
</script>

<style scoped>

</style>
